import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";

import applicationService from "services/ApplicationService";
import { message } from "antd";

export const initialState = {
  loadingApplicants: false,
  applicants: [],
  totalRecord: 0,
  loadingApplicationById: false,
  loadingBulkCreate: false,
  loadingGetAppByCanId: false,
  getAppByCanIdData: [],
  //   loadingSetActive: false,
  loadingBulkChangeStatus: false,
  loadingCreateApplication: false,
  loadingApproveApplication: false,
  loadingAssignToHRAssessment: false,
  applicationHistory: [],
  appStatus: [],
  loadingAppStatus: false,
};

export const GetApplicationSSR = createAsyncThunk(
  "/Application/GetAllSSR",
  async (data, { rejectWithValue }) => {
    try {
      const response = await applicationService.GetApplicationSSR(data);
      if (response.success === false) {
        return rejectWithValue(response.message);
      } else {
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const CreateApplication = createAsyncThunk(
  "/Application/Create",
  async (data, { rejectWithValue }) => {
    try {
      const response = await applicationService.Create(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const BulkCreateApplication = createAsyncThunk(
  "/Application/CreateRange",
  async (data, { rejectWithValue }) => {
    try {
      const response = await applicationService.BulkCreate(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetApplicationsByCandidateId = createAsyncThunk(
  "/Application/GetApplicationsByCandidateId",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await applicationService.GetApplicationsByCandidateId({
        id,
      });

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetApplicationById = createAsyncThunk(
  "/Application/GetById",
  async ({ id }, { rejectWithValue }) => {
    try {
      const response = await applicationService.GetApplicationById({ id });

      return response;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetActive = createAsyncThunk(
  "/Application/SetIsActive",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetActive({ id, status });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const GetApplicationStatus = createAsyncThunk(
  "/Application/GetApplicationStatus",
  async (_, { rejectWithValue }) => {
    try {
      const response = await applicationService.GetApplicationStatus();

      return response.result;
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsViewedStatus = createAsyncThunk(
  "/Application/SetIsViewed",
  async ({ applicationId, status }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetIsViewedStatus({
        applicationId,
        status,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsDownloadedStatus = createAsyncThunk(
  "/Application/SetIsDownloaded",
  async ({ applicationId, status, role }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetIsDownloadedStatus({
        applicationId,
        status,
        role,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      }
      // else {
      //   message.success({
      //     content: ` ${response.message}`,
      //   });
      //   return response.result;
      // }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsShortListedStatus = createAsyncThunk(
  "/Application/SetIsShortListed",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetIsShortListedStatus({
        id,
        status,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsHiredStatus = createAsyncThunk(
  "/Application/SetIsHired",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetIsHired({
        id,
        status,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const SetIsScheduledStatus = createAsyncThunk(
  "/Application/SetIsScheduled",
  async ({ id, status }, { rejectWithValue }) => {
    try {
      const response = await applicationService.SetIsScheduled({
        id,
        status,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const ChangeStatus = createAsyncThunk(
  "/Application/ChangeStatus",
  async (data, { rejectWithValue }) => {
    try {
      const response = await applicationService.ChangeStatus(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response.result;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);

export const AssignToHRAssessment = createAsyncThunk(
  "/Application/AssignToHRAssessment",
  async ({ applicationId, hrAssessmentId }, { rejectWithValue }) => {
    try {
      const response = await applicationService.AssignToHRAssessment({
        applicationId,
        hrAssessmentId,
      });
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const ApproveApplication = createAsyncThunk(
  "/Application/ApproveApplication",
  async (data, { rejectWithValue }) => {
    try {
      const response = await applicationService.ApproveApplication(data);
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const BulkChangeStatusHired = createAsyncThunk(
  "/Application/BulkChangeStatus",
  async (data, { rejectWithValue }) => {
    const { statusId, body } = data;
    try {
      const response = await applicationService.BulkChangeStatus(
        { statusId },
        body
      );
      if (response.success === false) {
        message.error({
          content: ` ${response.message}`,
        });
        return response.result;
      } else {
        message.success({
          content: ` ${response.message}`,
        });
        return response;
      }
    } catch (err) {
      return rejectWithValue(
        err.response?.data?.message || "Something Went Wrong !"
      );
    }
  }
);
export const applicationSlice = createSlice({
  name: "application",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetApplicationSSR.pending, (state) => {
        state.loadingApplicants = true;
      })
      .addCase(GetApplicationSSR.fulfilled, (state, action) => {
        state.loadingApplicants = false;
        state.applicants = action.payload.data;
        state.totalRecord = action.payload.totalRecord;
      })
      .addCase(GetApplicationSSR.rejected, (state, action) => {
        state.applicants = [];
        state.loadingApplicants = false;
      })
      .addCase(GetApplicationById.pending, (state) => {
        state.loadingApplicationById = true;
      })
      .addCase(GetApplicationById.fulfilled, (state, action) => {
        state.loadingApplicationById = false;
        state.applicationHistory = action.payload.result.history;
      })
      .addCase(GetApplicationById.rejected, (state, action) => {
        state.loadingApplicationById = false;
        state.applicationHistory = [];
      })

      .addCase(GetApplicationStatus.pending, (state) => {
        state.loadingAppStatus = true;
      })
      .addCase(GetApplicationStatus.fulfilled, (state, action) => {
        state.loadingAppStatus = false;
        state.appStatus = action.payload;
      })
      .addCase(GetApplicationStatus.rejected, (state, action) => {
        state.loadingAppStatus = false;
        state.appStatus = [];
      })
      .addCase(BulkCreateApplication.pending, (state) => {
        state.loadingBulkCreate = true;
      })
      .addCase(BulkCreateApplication.fulfilled, (state, action) => {
        state.loadingBulkCreate = false;
      })
      .addCase(BulkCreateApplication.rejected, (state, action) => {
        state.loadingBulkCreate = false;
      })
      .addCase(AssignToHRAssessment.pending, (state) => {
        state.loadingAssignToHRAssessment = true;
      })
      .addCase(AssignToHRAssessment.fulfilled, (state, action) => {
        state.loadingAssignToHRAssessment = false;
      })
      .addCase(AssignToHRAssessment.rejected, (state, action) => {
        state.loadingAssignToHRAssessment = false;
      })
      .addCase(ApproveApplication.pending, (state) => {
        state.loadingApproveApplication = true;
      })
      .addCase(ApproveApplication.fulfilled, (state, action) => {
        state.loadingApproveApplication = false;
      })
      .addCase(ApproveApplication.rejected, (state, action) => {
        state.loadingApproveApplication = false;
      })
      .addCase(CreateApplication.pending, (state) => {
        state.loadingCreateApplication = true;
      })
      .addCase(CreateApplication.fulfilled, (state, action) => {
        state.loadingCreateApplication = false;
      })
      .addCase(CreateApplication.rejected, (state, action) => {
        state.loadingCreateApplication = false;
      })
      .addCase(BulkChangeStatusHired.pending, (state) => {
        state.loadingBulkChangeStatus = true;
      })
      .addCase(BulkChangeStatusHired.fulfilled, (state, action) => {
        state.loadingBulkChangeStatus = false;
      })
      .addCase(BulkChangeStatusHired.rejected, (state, action) => {
        state.loadingBulkChangeStatus = false;
      })
      .addCase(GetApplicationsByCandidateId.pending, (state) => {
        state.loadingGetAppByCanId = true;
      })
      .addCase(GetApplicationsByCandidateId.fulfilled, (state, action) => {
        state.loadingGetAppByCanId = false;
        state.getAppByCanIdData = action.payload;
      })
      .addCase(GetApplicationsByCandidateId.rejected, (state, action) => {
        state.loadingGetAppByCanId = false;
        state.getAppByCanIdData = [];
      });
  },
});

export const {} = applicationSlice.actions;

export default applicationSlice.reducer;
